import {
  Box,
  Typography,
  Button,
  Stack,
  Dialog,
  DialogTitle,
  Grid,
  IconButton,
  TextField,
  DialogContent,
  DialogActions,
  CircularProgress,
} from "@mui/material";
import React, { useState } from "react";
import heroImage from "../assets/images/home.png";
import { Helmet } from "react-helmet";
import { ReactComponent as Affordable } from "../assets/images/AffordableIcon.svg";
import Typing from "../components/Typing/Typing";
import { useNavigate } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";
import { toast } from "react-hot-toast";

function Home() {
  const [apiError, setApiError] = useState("");
  const [loading, setLoading] = useState(false);
  const [passwordError, setPasswordError] = useState(false);
  const [openSignup, setOpenSignup] = useState(false);
  const handleSignupOpen = () => setOpenSignup(true);
  const [formErrors, setFormErrors] = useState({});
  const handleSignupClose = () => setOpenSignup(false);
  const [signupData, setSignupData] = useState({
    name: "",
    email: "",
    phone: "",
    city: "",
    state: "",
    pincode: "",
    password: "",
    confirmPassword: "",
  });
  const navigate = useNavigate();
  const handleWhatsAppClick = () => {
    window.open("https://wa.me/919353511090", "_blank"); // Replace with your WhatsApp number
  };
  const validateForm = () => {
    const errors = {};
    if (!signupData.name.trim()) errors.name = "Name is required";
    if (!signupData.email) errors.email = "Email is required";
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(signupData.email))
      errors.email = "Invalid email format";

    if (!signupData.phone) errors.phone = "Phone number is required";
    else if (!/^\d{10}$/.test(signupData.phone))
      errors.phone = "Phone must be 10 digits";

    if (!signupData.state.trim()) errors.state = "State is required";
    if (!signupData.city.trim()) errors.city = "City is required";

    if (!signupData.pincode) errors.pincode = "Pincode is required";
    else if (!/^\d{6}$/.test(signupData.pincode))
      errors.pincode = "Pincode must be 6 digits";

    if (!signupData.password) errors.password = "Password is required";
    if (!signupData.confirmPassword)
      errors.confirmPassword = "Confirm password is required";
    else if (signupData.password !== signupData.confirmPassword) {
      errors.confirmPassword = "Passwords do not match";
      setPasswordError(true);
    } else {
      setPasswordError(false);
    }

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setSignupData((prev) => ({ ...prev, [name]: value }));

    if (name === "password" || name === "confirmPassword") {
      setPasswordError(
        name === "confirmPassword"
          ? value !== signupData.password
          : signupData.confirmPassword !== value
      );
    }
  };

  const handleSubmit = async () => {
    if (!validateForm()) return;
    if (signupData.password !== signupData.confirmPassword) {
      setPasswordError(true);
      return;
    }

    setPasswordError(false);
    setApiError("");
    setLoading(true);

    try {
      const response = await fetch(
        "http://43.204.235.152:8000/api/users/signup",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            Name: signupData.name,
            Email: signupData.email,
            Mobile_Number: signupData.phone,
            State: signupData.state,
            City: signupData.city,
            Pincode: signupData.pincode,
            Password: signupData.confirmPassword,
          }),
        }
      );

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.data || "Signup failed");
      }

      toast.success("Signup successful!");
      navigate("/disclaimer", { state: { signupData } });
    } catch (err) {
      setApiError(err.message);
    } finally {
      setLoading(false);
    }
  };
  const handleInvest = () => {
    navigate("/disclaimer");
  };
  const handleInvestNow = () => {
    navigate("/project");
    // const storedData = JSON.parse(sessionStorage.getItem("projectData"));
    // navigate("/krishi-vriddhi", {
    //   state: {
    //     project: storedData.projects[0],
    //     crops: storedData.crops || [],
    //     crop_expenses: storedData.crop_expenses || [],
    //     transactions: storedData.transactions || {},
    //   },
    // });
  };
  return (
    <>
      <Helmet>
        <title>InvestoFarms</title>
        <meta
          name="description"
          content="This is the home page description for SEO."
        />
        <meta name="keywords" content="home, affordable, typing, react" />
      </Helmet>
      <Box
        sx={{
          backgroundImage: `url(${heroImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          height: { xs: "auto", md: "inherit" },
        }}
      >
        <Box
          sx={{
            width: { xs: "100%", md: "90%" },
            height: { xs: "auto", md: "inherit" },
            display: "flex",
            flexDirection: "column",
            alignItems: { xs: "flex-start" },
            p: { xs: 2, md: 10 },
            m: "auto",
            gap: { xs: "16px", md: "8px" },
          }}
        >
          <Affordable />
          <Typography
            variant="h2"
            color="#EBB912"
            fontWeight="bold"
            width="100%"
            sx={{ fontSize: { xs: "32px", md: "55px" } }}
          >
            Own the Harvest, We Handle the Rest
          </Typography>
          <Typing />
          <Typography
            sx={{ fontSize: "14px", width: { xs: "80%", md: "60%" } }}
          >
            At InvestoFarms, we are redefining agriculture through our Krishi
            Vriddhi mode. We lease large extensive land parcels and offer
            expertly managed plots to clients like you. You retain full rights
            to your harvest, while our team handles everything from soil testing
            to selling the produce{" "}
          </Typography>
          <Stack
            // direction="row"
            direction={{ xs: "column", sm: "row" }}
            spacing={2}
            sx={{ marginTop: { xs: "10px", md: "30px" } }}
          >
            <Button
              variant="contained"
              sx={{
                borderRadius: "40px",
                p: 1,
                width: "290px",
                height: "50px",
                backgroundColor: "#23766a",
                textTransform: "capitalize",
                "&:hover": {
                  backgroundColor: "#EBB912", // Background color on hover
                  color: "#23766a", // Text color on hover
                },
              }}
              onClick={handleInvestNow}
            >
              Start Your Farming Journey
            </Button>
            <Button
              variant="contained"
              sx={{
                borderRadius: "40px",
                p: 1,
                width: "130px",
                height: "50px",
                textTransform: "capitalize",
                backgroundColor: "#23766a",
                "&:hover": {
                  backgroundColor: "#EBB912", // Background color on hover
                  color: "#23766a", // Text color on hover
                },
              }}
              onClick={handleWhatsAppClick}
            >
              Contact Us
            </Button>
          </Stack>
        </Box>
        <Dialog
          open={openSignup}
          onClose={handleSignupClose}
          fullWidth
          maxWidth="sm"
        >
          <DialogTitle
            sx={{
              backgroundColor: "#23766a",
              color: "white",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            Create Your Account
            <IconButton onClick={handleSignupClose} sx={{ color: "white" }}>
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent sx={{ pt: 3 }}>
            <Grid container spacing={{ xs: 1, sm: 2 }}>
              {[
                { name: "name", label: "Full Name", md: 12 },
                { name: "email", label: "Email Address", md: 6, type: "email" },
                { name: "phone", label: "Phone Number", md: 6 },
                { name: "state", label: "State", md: 4 },
                { name: "city", label: "City", md: 4 },
                { name: "pincode", label: "Pincode", md: 4 },
                {
                  name: "password",
                  label: "Password",
                  md: 6,
                  type: "password",
                },
                {
                  name: "confirmPassword",
                  label: "Confirm Password",
                  md: 6,
                  type: "password",
                },
              ].map((field) => (
                <Grid key={field.name} item xs={12} md={field.md}>
                  <TextField
                    fullWidth
                    margin="normal"
                    name={field.name}
                    label={field.label}
                    type={field.type || "text"}
                    value={signupData[field.name]}
                    onChange={handleChange}
                    error={
                      !!formErrors[field.name] ||
                      (field.name === "confirmPassword" && passwordError)
                    }
                    helperText={
                      formErrors[field.name] ||
                      (field.name === "confirmPassword" && passwordError
                        ? "Passwords do not match"
                        : "")
                    }
                    variant="outlined"
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                          borderColor: "#1a5c54",
                        },
                        "&:hover fieldset": {
                          borderColor: "#1a5c54",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: "#1a5c54",
                        },
                      },
                      "& .MuiInputLabel-root": {
                        color: "#1a5c54",
                        "&.Mui-focused": {
                          color: "#1a5c54",
                        },
                      },
                      // Responsive adjustments
                      "& .MuiInputBase-input": {
                        fontSize: { xs: "0.875rem", sm: "1rem" },
                        padding: { xs: "10.5px 14px", sm: "12.5px 14px" },
                      },
                      "& .MuiInputLabel-root": {
                        fontSize: { xs: "0.875rem", sm: "1rem" },
                        transform: {
                          xs: "translate(14px, 12px) scale(1)",
                          sm: "translate(14px, 16px) scale(1)",
                        },
                      },
                      "& .MuiInputLabel-shrink": {
                        transform: {
                          xs: "translate(14px, -6px) scale(0.75)",
                          sm: "translate(14px, -9px) scale(0.75)",
                        },
                      },
                    }}
                    InputLabelProps={{
                      sx: {
                        // Additional responsive adjustments for the label
                        lineHeight: { xs: "1.2", sm: "1.4375em" },
                      },
                    }}
                  />
                </Grid>
              ))}
            </Grid>
            {apiError && (
              <Typography
                color="error"
                sx={{ mt: 2, fontSize: { xs: "0.875rem", sm: "1rem" } }}
              >
                {apiError}
              </Typography>
            )}
          </DialogContent>
          <DialogActions sx={{ px: 3, pb: 3 }}>
            <Button
              onClick={handleSignupClose}
              disabled={loading}
              variant="outlined"
              sx={{
                mr: 2,
                color: "#1a5c54",
                borderColor: "#1a5c54",
                "&:hover": {
                  borderColor: "#1a5c54",
                  backgroundColor: "rgba(26, 92, 84, 0.04)", // Optional: subtle hover effect
                },
                "&.Mui-disabled": {
                  color: "rgba(26, 92, 84, 0.38)",
                  borderColor: "rgba(26, 92, 84, 0.38)",
                },
              }}
            >
              Cancel
            </Button>
            <Button
              onClick={handleSubmit}
              disabled={loading}
              variant="contained"
              sx={{
                backgroundColor: "#23766a",
                "&:hover": { backgroundColor: "#1a5c54" },
                width: "30vh",
                height: "5vh",
                position: "relative", // Ensures the spinner is positioned inside the button
                padding: "10px 20px", // Add padding to make space for the spinner
              }}
            >
              {loading ? (
                <Box
                  sx={{
                    position: "absolute",
                    top: "60%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                  }}
                >
                  <CircularProgress size={24} sx={{ color: "white" }} />
                </Box>
              ) : (
                "Sign Up & Continue"
              )}
            </Button>
          </DialogActions>
        </Dialog>
      </Box>
    </>
  );
}
export default Home;
